<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm"
          :model="step2"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
          <FormItem label="所在行业" prop="industryId" style="width:100%">
            <Select v-model="step2.industryId" filterable placeholder="选择专属行业/领域">
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <div class="padding-top-20"></div><div class="padding-top-20"></div>
        </Form>
        </vue-scroll>
      </div>
      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="4"><Button type="primary" ghost size="large" style="display:inline" long @click="backward">上一步</Button></Col>
          <Col span="16"><Button type="primary" size="large" style="display:inline" long @click="submit">下一步</Button></Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'guarantor-new',
  props: {
    data: Object
  },
  data () {
    return {
      loading: false,
      step2: {
        industryId: null,
      },
      modelValidate: {
        industryId: [
          { required: true, type: 'number', message: '请选择行业/领域', trigger: 'blur' }
        ]
      },
      industries: [],
      industryRecords: []
    }
  },
  watch: {
  },
  mounted () {
    this.initIndustrySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    backward () {
      this.$emit('go-backward')
    },
    initIndustrySelect () {
      if (this.checkRolePermitted(['保证人'])) {
        Api.Guarantor.getMyPermittedIndustries(this.data.cityId).then((res) => {
          let data = res.map((c) => {
            return {
              id: c.industryId,
              value: c.industryId,
              label: c.industryName
            }
          })
          this.industryRecords = res
          this.industries = data
        }).catch(err => {
          this.$Message.error('获取行业列表失败!' + err.message)
        })
      } else if (this.checkRolePermitted(['监管人','总监管人','管理员'])) {
        Api.Supervisor.getMySupervisorDetail().then((res) => {
          let data = res.industries.map((c) => {
            return {
              id: c.industry.id,
              value: c.industry.id,
              label: c.name
            }
          })
          this.industryRecords = res.industries
          this.industries = data
        }).catch(err => {
          this.$Message.error('获取行业列表失败!' + err.message)
        })
      }
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          let ind = this.industryRecords.filter((i) => {
            if (i.industry) {
              return i.industry.id === this.step2.industryId
            } else {
              return i.industryId === this.step2.industryId
            }
          })
          this.$emit('finish-step2', ind[0])
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {

  }
}
</style>
